import { useChatStore } from "@/store/chat/ChatStore";

const showNotification = (messageInfo, from, message) => {
  const icon = `${require("@/assets/images/logo.webp")}`;
  const title = `New message : ${messageInfo.alternateOrderNumber}`;
  const messageOn = message.length > 100 ? message.substring(0, 100) : message;
  const body = from + " : " + messageOn;
  const notification = new Notification(title, { body, icon });
  notification.onclick = () => {
    openChatHub(messageInfo);
    notification.close();
    window.parent.focus();
  };
};

const openChatHub = async messageInfo => {
  const chatStore = useChatStore();
  await chatStore.fetchMessagesForActiveChat(messageInfo.bookingId);
  chatStore.isChatActive = true;
  chatStore.toggleChatHubMode(true);
};

const requestAndShowPermission = (messageInfo, from, message) => {
  Notification.requestPermission(function (permission) {
    if (permission === "granted") {
      showNotification(messageInfo, from, message);
    }
  });
};

export { showNotification, requestAndShowPermission };
